import { useTaxDispatch, useTaxSelector } from "../../redux/general/reduxStore";
import { ControlPosition } from "react-draggable";
import { saveDialogPosition } from "../../redux/applicationSettingsSlice";
import React from "react";

export default function useDialogPosition(dialogId?: string) {
    const dispatch = useTaxDispatch();
    const position: ControlPosition | undefined = useTaxSelector((state) => (dialogId ? state.taxSettings.dialogPositions?.[dialogId] : undefined));

    const savePosition = React.useCallback(
        (position: ControlPosition) => {
            if (dialogId) {
                dispatch(saveDialogPosition({ dialogId, position }));
            }
        },
        [dialogId, dispatch]
    );

    return React.useMemo(
        () => ({
            position,
            savePosition,
        }),
        [position?.x, position?.y, savePosition]
    );
}